import { observer } from "mobx-react-lite";
import * as React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import DocumentViewer from "../components/DocumentViewer";
import { useDocumentsStore } from "../stores/context";

const DocumentViewerPage: React.FC = () => {
    const { documentViewVisualStore } = useDocumentsStore();
    const { documentId } = useParams();
    const [searchParams] = useSearchParams();
    const documentName = searchParams.get("fileName");

    if (!documentId) {
        return null;
    }

    return (
        <div className="document-viewer-page">
            {documentName ? (
                <h1 className="document-viewer-page-title">{documentName}</h1>
            ) : null}
            <DocumentViewer store={documentViewVisualStore} path={documentId} />
        </div>
    );
};

export default observer(DocumentViewerPage);
